const u = window.navigator.userAgent
export default {
  trident: u.indexOf('Trident') > -1, //IE内核
  presto: u.indexOf('Presto') > -1, //opera内核
  webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
  gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
  mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
  ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
  android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
  iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
  iPad: u.indexOf('iPad') > -1, //是否iPad
  webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
  wechat: u.match(/MicroMessenger/i) == "micromessenger", //微信
  weibo: u.match(/WeiBo/i) == "weibo", //微博
  qq: u.match(/QQ/i) == "qq", //QQ空间

	formatAmount(n, d, s) {
		let p = '';
		if (typeof n === 'string') {
			/^([^\d\.]+)([\d\.]+)$/.test(n) && (p = RegExp.$1, n = RegExp.$2);
		}
		if (isNaN(n)) {
			n = 0;
		}
		if (typeof d === 'string' || typeof s === 'number') {
			[d, s] = [s, d];
		}
		if (d === 0) {
			n = Math.round(n);
		} else if (d > 0 || d < 0) {
			let v = Math.pow(10, d);
			n = Math.round(n * v) / v;
		}
		n = n + '';
		if (!s || n < 1000) {
			return  p + n;
		}
		let ss = (n + '').split('.'), m = ss[0], l = m.length, r = l % 3 || 3;
		let i = 0, f = m.substr(0, r);
		for (i = r; i < l; i += 3) {
			f += s + m.substr(i, 3);
		}
		return p + f + (ss[1] ? ('.' + ss[1]) : '');
	},
}



// WEBPACK FOOTER //
// ./src/utils/app.js